import React from 'react';
import { InfoLabel } from '../../../../common/components';
import displayName from '../../../../helpers/displayName';
import { Col, Row } from 'react-bootstrap';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import formatDateTime from '../../../../helpers/formatDateTime';
import { FullRow } from '../../../layout/components';
import formatDate from '../../../../helpers/formatDate';
import { Link } from 'react-router';

const LABEL_SIZE = 5;

const PolicyReference = ({ policyId, policyNumber }) => {
  if (!policyNumber) {
    return null;
  }

  if (policyId) {
    return (
      <Link to={'/policies/issued/' + policyId} onlyActiveOnIndex>
        {policyNumber}
      </Link>
    );
  }
  return policyNumber;
};

const MtaRequestDetails = ({ mtaRequest }) => {
  const respondedByUser = getIncludedResource(
    mtaRequest.data,
    mtaRequest.included,
    'responded_by',
  );
  const policy = getIncludedResource(mtaRequest.data, mtaRequest.included, 'policy');

  return (
    <>
      <h2 className="resource-name">
        MTA Request - {mtaRequest.data.attributes.reference}
      </h2>

      <Row>
        <Col sm={6}>
          <InfoLabel
            label="Status"
            value={displayName(mtaRequest.data.attributes.status)}
            labelSize={LABEL_SIZE}
          />
          <InfoLabel
            label="Lead Traveller"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.name}
          />
          <InfoLabel
            label="Policy Reference"
            labelSize={LABEL_SIZE}
            value={
              <PolicyReference
                policyId={policy.data.id}
                policyNumber={mtaRequest.data.attributes.metadata.policy_number}
              />
            }
          />
          <InfoLabel
            label="Adjustment Type"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.mta_type}
          />
          <InfoLabel
            label="Email Address"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.email}
          />
          <InfoLabel
            label="Telephone Number"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.phone}
          />
        </Col>
        <Col sm={6}>
          <InfoLabel
            label="Date of Birth:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.dob}
          />
          <InfoLabel
            label="Trip Type:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.trip_type}
          />
          <InfoLabel
            label="Destination/Region:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.destination}
          />
          <InfoLabel
            label="Start Date:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.start_date}
          />
          <InfoLabel
            label="End Date:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.end_date}
          />

          <InfoLabel
            label="Issue Date:"
            labelSize={LABEL_SIZE}
            value={mtaRequest.data.attributes.metadata.issue_date}
          />
          <InfoLabel
            label="Has the trip been cancelled:"
            labelSize={10}
            value={mtaRequest.data.attributes.metadata.cancelled_by_agent}
          />

          <InfoLabel
            label="Will the trip be rescheduled:"
            labelSize={10}
            value={mtaRequest.data.attributes.metadata.rescheduled}
          />

          <InfoLabel
            label="Has the customer received a full refund:"
            labelSize={10}
            value={mtaRequest.data.attributes.metadata.refund}
          />
        </Col>
      </Row>
      <hr />
      <FullRow>
        <InfoLabel label="Additional Notes" value={mtaRequest.data.attributes.message} />
      </FullRow>
      {respondedByUser.data.attributes && (
        <>
          <hr />
          <FullRow>
            <InfoLabel
              label="Responded To By"
              labelSize={LABEL_SIZE}
              value={respondedByUser.data.attributes.full_name}
            />

            <InfoLabel
              label="Date Responded"
              value={formatDateTime(mtaRequest.data.attributes.responded_at)}
              labelSize={LABEL_SIZE}
            />
          </FullRow>
        </>
      )}
    </>
  );
};
export default MtaRequestDetails;
